import {
  Field,
  FieldContent,
  FieldLabel,
} from "@frontend/components/atoms/Field";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@frontend/components/atoms/Select";
import { Switch } from "@frontend/components/atoms/Switch";
import { Trans, useLingui } from "@lingui/react/macro";

import type { LocationTypedAddress } from "../types";

export type ExistingAddressPickerProps = {
  createNew: boolean;
  onToggleCreateNew: (checked: boolean) => void;
  existingAddressId: number | null;
  addresses: LocationTypedAddress[];
  onSelectAddress: (addressId: number) => void;
};

export function ExistingAddressPicker({
  createNew,
  onToggleCreateNew,
  existingAddressId,
  addresses,
  onSelectAddress,
}: ExistingAddressPickerProps) {
  const { t } = useLingui();

  const items = addresses.map((address) => ({
    value: String(address.id),
    label: address.displayAddress || address.place || `#${address.id}`,
  }));

  return (
    <>
      <Field>
        <FieldContent>
          <Switch
            label={t`Create a new address`}
            checked={createNew}
            onCheckedChange={onToggleCreateNew}
            disabled={addresses.length === 0}
          />
        </FieldContent>
      </Field>

      <Field>
        <FieldLabel>
          <Trans>Existing address</Trans>
        </FieldLabel>
        <FieldContent>
          <Select
            items={items}
            value={existingAddressId != null ? String(existingAddressId) : null}
            onValueChange={(value) => {
              if (value) {
                onSelectAddress(Number(value));
              }
            }}
            disabled={createNew || items.length === 0}
          >
            <SelectTrigger>
              <SelectValue placeholder={t`Choose an address`} />
            </SelectTrigger>
            <SelectContent>
              {items.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FieldContent>
      </Field>
    </>
  );
}
